import { StrictMode } from "react";
import "./index.css";

import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";

import App from "./App.tsx";
import i18next from "./i18n/config";

import { Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import { env } from "./lib/env.ts";
Providers.globalProvider = new Msal2Provider({
  clientId: env.VITE_APP_REGISTRATION_ID,
  authority: `https://login.microsoftonline.com/${env.VITE_ENTRA_TENANT_ID}`,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </StrictMode>
);
